import {
    TRAINING_LOG_CREATE,
    TRAINING_LOG_CREATE_FAIL,
    TRAINING_LOG_CREATE_SUCCESS,
    DELETE_TRAINING_LOG,
    DELETE_TRAINING_LOG_FAIL,
    DELETE_TRAINING_LOG_SUCCESS,
    GET_TRAINING_LOG_DETAILS,
    GET_TRAINING_LOG_DETAILS_FAIL,
    GET_TRAINING_LOG_DETAILS_SUCCESS,
    RESET,
    RESET_TRAINING_LOG_CREATE,
    RESET_TRAINING_LOG_DELETE,
    RESET_TRAINING_LOG_DETAILS,
    UPDATE_TRAINING_LOG,
    UPDATE_TRAINING_LOG_FAIL,
    UPDATE_TRAINING_LOG_SUCCESS,
    GET_TRAINING__AUDIT_LOGS,
    GET_TRAINING__AUDIT_LOGS_SUCCESS,
    GET_TRAINING__AUDIT_LOGS_FAIL,
} from "./actionsTypes";

const initialState = {
    trainingLogList: [],
    trainingLogDetails: [],
    createResult: {},
    loading: false,
    detailsLoading: false,
    loadingCreate: false,
    deleteResult: {},
    auditLogs: [],
    auditLogsLoading: false,
    error: {
        message: "",
    },
};

const TrainingLogReducer = (state = initialState, action) => {
    if (!action) return state;

    switch (action.type) {
        case TRAINING_LOG_CREATE:
            state = { ...state, createResult: {}, loadingCreate: true };
            break;
        case TRAINING_LOG_CREATE_SUCCESS:
            state = { ...state, createResult: action.payload, loadingCreate: false };
            break;
        case TRAINING_LOG_CREATE_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                createResult: {},
                loadingCreate: false,
            };
            break;

        case GET_TRAINING_LOG_DETAILS:
            state = { ...state, detailsLoading: true, trainingLogDetails: {} };
            break;
        case GET_TRAINING_LOG_DETAILS_SUCCESS:
            state = { ...state, trainingLogDetails: action.payload, detailsLoading: false };
            break;
        case GET_TRAINING_LOG_DETAILS_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                detailsLoading: false,
            };
            break;

        case UPDATE_TRAINING_LOG:
            state = { ...state, createResult: {}, loading: true };
            break;
        case UPDATE_TRAINING_LOG_SUCCESS:
            state = { ...state, createResult: action.payload, loading: false };
            break;
        case UPDATE_TRAINING_LOG_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
            };
            break;

        case DELETE_TRAINING_LOG:
            state = { ...state, deleteResult: {}, loading: true, };
            break;
        case DELETE_TRAINING_LOG_SUCCESS:
            state = { ...state, deleteResult: action.payload, loading: false };
            break;
        case DELETE_TRAINING_LOG_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
                deleteResult: {}
            };
            break;
        case RESET_TRAINING_LOG_DETAILS:
            state = { ...state, trainingLogDetails: {}, detailsLoading: false };
            break;


        case GET_TRAINING__AUDIT_LOGS:
            state = { ...state, auditLogsLoading: true, auditLogs: [] };
            break;
        case GET_TRAINING__AUDIT_LOGS_SUCCESS:
            state = { ...state, auditLogs: action.payload, auditLogsLoading: false };
            break;
        case GET_TRAINING__AUDIT_LOGS_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                auditLogsLoading: false,
            };
            break;

        case RESET:
            state = { ...state, trainingLogList: [], createResult: {} };
            break;
        case RESET_TRAINING_LOG_CREATE:
            state = { ...state, createResult: {} };
            break;
        case RESET_TRAINING_LOG_DELETE:
            state = { ...state, deleteResult: {} };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default TrainingLogReducer;